import styles from './upload-footer-inbox.module.css'

import React from 'react'

import mixpanel from '@disco/api/mixpanel'
import {
  DISCO_SITE_FROM_BRIEF_SUBMISSION_URL,
  DISCO_SITE_FROM_PUBLIC_INBOX_URL,
} from '@disco/constants/external-links'
import businessCookie from '@disco/utils/business-cookie'

import { Flex, Text } from 'components/ds'

import FooterLogo from 'pages/upload/footer-logo'

const UploadFooterInbox = ({
  displayLogo = true,
  businessName,
  isBrief = false,
}: {
  displayLogo?: boolean
  businessName: string
  isBrief?: boolean
}): React.ReactElement<'div'> => {
  const firstExistingBusiness = businessCookie()[0]

  if (firstExistingBusiness) {
    return null
  }

  const siteUrl = isBrief
    ? DISCO_SITE_FROM_BRIEF_SUBMISSION_URL
    : DISCO_SITE_FROM_PUBLIC_INBOX_URL
  const utmMedium = isBrief ? 'brief_submission' : 'public_inbox'

  return (
    <Flex direction="column" align="center">
      {displayLogo && (
        <FooterLogo
          link={siteUrl}
          onClick={() =>
            mixpanel.sendPureEvent('Click DISCO logo', {
              Type: 'DISCO Logo',
              Location: 'Upload',
              'UTM Source': 'disco_playlist',
              'UTM Medium': utmMedium,
            })
          }
        />
      )}
      <Text weight="medium" className={styles['upload-footer-inbox-text']}>
        Trusted by over 20,000 teams including {businessName}
      </Text>
    </Flex>
  )
}

export default UploadFooterInbox
